import React from 'react';
import { Layout } from 'antd';
import styled from 'styled-components';
import NwListHeader from './NwListHeader';
import NwFooter from './NwFooter';

const Wrapper = styled(Layout)`
    color: ${props => props.theme.TextColor};
    background-color: ${props => props.theme.LayoutBodyBackground};
    transition: all 0.2s;


  .ant-layout-header {
    height: ${props => !props.model ? props.theme.LayoutHeaderHeight : props.theme.LayoutHeaderHeight + 20}px;
    line-height: ${props => props.theme.LayoutHeaderHeight}px;
    padding: 0;
    position: fixed;
    z-index: 100;
    background: ${props => props.theme.LayoutBodyBackground} !important;
    width: ${props => props.siderCollapsed ? 'calc(100vw - 80px)' : 'calc(100vw - 200px)'};
    padding: 0 !important;
    color: ${props => props.theme.TextColor};
    transition: all 0.2s;
    border-bottom: ${props => props.theme.DefaultBorder};
    a {
      color: ${props => props.theme.TextColor};
    }
    @media (max-width: 640px) {
      width: 100vw;
      height: ${props => props.model ? props.theme.LayoutHeaderMiniViewHeight : props.theme.LayoutHeaderHeight}px;
      line-height: calc(100vh - ${props => props.model ? props.theme.LayoutHeaderMiniViewHeight : props.theme.LayoutHeaderHeight}px);
    }
  }
  .ant-layout-content {
    /* margin-top: ${props => !props.model ? props.theme.LayoutHeaderHeight : props.theme.LayoutHeaderHeight + 20}px; */
    margin-top: ${props => !props.model ? '0' : '20px'};

    @media (max-width: 640px) {
        margin: 1rem 1rem 3rem 1rem;
    }

    //min-height: calc(100vh - ${props => !props.model ? props.theme.LayoutHeaderHeight : props.theme.LayoutHeaderHeight + 20}px);

    @media (max-width: 640px) {
      //margin-top: ${props => props.model ? 0 : props.theme.LayoutHeaderHeight}px;
      //min-height: calc(100vh - ${props => props.model ? 0 : props.theme.LayoutHeaderHeight}px);
    }
  }
`;

const NwListLayout = ({
  children
}) => {

  return (
    <Wrapper>
      <NwListHeader />
      {children}
      <NwFooter />
    </Wrapper>
  )
};

export default NwListLayout;
